module.exports = __webpack_public_path__ + "static/media/landing-kitty02.fae6ae54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/home-page/landing-kitty02.svg
// module id = 119
// module chunks = 0